import { useSyncExternalStore } from 'react'

import { getAccessToken, subscribeToAuthChanges } from '../features/auth'

export const useJWT = () => {
	const accessToken = useSyncExternalStore(subscribeToAuthChanges, getAccessToken, getAccessToken)
	return { jwt: accessToken, accessToken }
}
